import { Component, inject, OnChanges, WritableSignal, signal, input } from '@angular/core';
import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { firstValueFrom } from 'rxjs';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { AddressChangeDto, AssignmentService, AssignmentType } from '../../shared/generated/backend';
import { SharedModule } from '../../shared/shared.module';
@Component({
  selector: 'app-assignment-address',
  imports: [SharedModule, RichTextEditorModule, DxDataGridModule, IconComponent],
  standalone: true,
  templateUrl: './assignment-address.component.html',
  styleUrl: './assignment-address.component.scss',
})
export class AssignmentAddressComponent implements OnChanges {
  readonly assignmentId = input.required<number>();

  readonly type = input.required<AssignmentType>();

  addresses: WritableSignal<AddressChangeDto[]> = signal([]);
  readonly isLoading: WritableSignal<boolean> = signal(false);

  private assignmentService = inject(AssignmentService);

  async ngOnChanges() {
    this.isLoading.set(true);
    const dto = await firstValueFrom(this.assignmentService.getAddresses(this.assignmentId(), this.type()));
    // console.log(this.assignmentId);
    this.addresses.set(dto);
    this.isLoading.set(false);
  }
}
